var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aup-saving-section-overlay w-100 h-100 d-flex justify-content-center align-items-center"},[_c('BaseBoxLoader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }